export default __webpack_public_path__ + "static/media/greeni-2.0bf5637e.jpg";